import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=3910f527&scoped=true&lang=html&"
import script from "./sso.vue?vue&type=script&lang=ts&"
export * from "./sso.vue?vue&type=script&lang=ts&"
import style0 from "./sso.vue?vue&type=style&index=0&id=3910f527&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910f527",
  null
  
)

export default component.exports